import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import drEasyApi from '../Api/Customapi';

export const useEmployees = () => {
    const queryClient = useQueryClient();

    const useGetEmployees = (startDate, endDate,isDeleted) => useQuery({
    queryKey: ["employees", startDate, endDate, isDeleted],
        refetchOnWindowFocus:true,
        queryFn: async () => {
            const { data } = await drEasyApi.get('/api/Employees/GetEmployeesWithStatus', {
                params: {
                    StartDate: startDate,
                    EndDate: endDate,
                              ...(isDeleted === true && { IsDeleted: true }),

                },
            });
            return data;
        },
    });

    const useCreateEmployee = () => useMutation({
        mutationFn: ({ firstName, lastName, email, password, jobTitle, salaryType, salary, dailyHours, weeklyDays, photoID }) =>
            drEasyApi.post('/api/Employees/Create', {
                firstName,
                lastName,
                email,
                password,
                jobTitle,
                salaryType,
                salary,
                dailyHours,
                weeklyDays,
                photoID,
            }),
        onSuccess: (response) => {
            queryClient.invalidateQueries(['employees']);
            message.success('Employee created successfully');
            return response.data;
        },
        onError: (error) => message.error(error.response?.data?.[0] || 'Failed to create employee'),
    });

    const useUpdateEmployee = () => useMutation({
        mutationFn: ({ id, fullName, jobTitle, salaryType, salary, dailyHours, weeklyDays, email, newPassword, photoID }) =>
            drEasyApi.put('/api/Employees/Edit', {
                id,
                fullName,
                jobTitle,
                salaryType,
                salary,
                dailyHours,
                weeklyDays,
                email,
                newPassword,
                photoID,
            }),
        onSuccess: () => {
            queryClient.invalidateQueries(['employees']);
            message.success('Employee updated successfully');
        },
        onError: (error) => message.error(error.response?.data?.[0] || 'Failed to update employee'),
    });

    const useDeleteEmployee = () => useMutation({
        mutationFn: (id) => drEasyApi.delete('/api/Employees/Delete', { params: { Id: id } }),
        onSuccess: () => {
            queryClient.invalidateQueries(['employees']);
            message.success('Employee deleted');
        },
        onError: (error) => message.error(error.response?.data?.[0] || 'Failed to delete employee'),
    });

    const useGetEmployeeShifts = (id, startDate, endDate) => useQuery({
        queryKey: ['employeeShifts', id, startDate, endDate],
        queryFn: async () => {
            const { data } = await drEasyApi.get('/api/Employees/EmployeeShifts', {
                params: {
                    EmployeeId: id,
                    StartDate: startDate,
                    EndDate: endDate,
                },
            });
            return data;
        },
        enabled: !!id,
    });

    const useDoctorPerformance = (id, startDate, endDate) => useQuery({
        queryKey: ['doctorPerformance', id, startDate, endDate],
        queryFn: async () => {
            const { data } = await drEasyApi.get('/api/Employees/DoctorPerformance', {
                params: {
                    DoctorId: id,
                    StartDate: startDate,
                    EndDate: endDate,
                },
            });
            return data;
        },
        enabled: !!id,
    });

    const useToggleShift = () => useMutation({
        mutationFn: (id) => drEasyApi.post('/api/Employees/ToggleShift', { employeeId: id }),
        onSuccess: () => {
            queryClient.invalidateQueries(['employees']);
        },
        onError: (error) => message.error(error.response?.data?.[0] || 'Failed to toggle shift'),
    });

    return {
        useGetEmployees,
        useCreateEmployee,
        useUpdateEmployee,
        useDeleteEmployee,
        useToggleShift,
        useGetEmployeeShifts,
        useDoctorPerformance,
    };
};